/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.wireframe-container-neurology {
  @include mixins.page-grid-basics;
  grid-template-columns: 0.5fr 0.5fr;
  grid-template-rows: max-content max-content auto;
  grid-template-areas:
    'gcs gcs'
    '. .'
    '. .';
}

.gcs {
  grid-area: gcs;
}
